import AttributesSelector from "./AttributesSelector.svelte"
import AttributesSelectorToggle from "./AttributesSelectorToggle.svelte"
import AttributeToggle from "./AttributeToggle.svelte"
import AttributeToggleGroup from "./AttributeToggleGroup.svelte"
import Button from "./Button.svelte"
import ModeButton from "./ModeButton.svelte"
import ModeSelector from "./ModeSelector.svelte"
import RefreshButton from "./RefreshButton.svelte"
import ShareScreen from "./ShareScreen.svelte"
import Typeface from "./Typeface.svelte"
import TypefacePagesDropdown from "./TypefacePagesDropdown.svelte"
import Typefaces from "./Typefaces.svelte"
import TypeSample from "./TypeSample.svelte"
import TypeWriter from "./TypeWriter.svelte"

export default {
  AttributesSelector,
  AttributesSelectorToggle,
  AttributeToggle,
  AttributeToggleGroup,
  Button,
  ModeButton,
  ModeSelector,
  RefreshButton,
  ShareScreen,
  Typeface,
  TypefacePagesDropdown,
  Typefaces,
  TypeSample,
  TypeWriter,
}
